
<template>
  <header class="hidden lg:flex bg-white border-b border-gray-200 px-6 py-4 items-center justify-between shrink-0 sticky top-0 z-30">
    <div class="flex items-center gap-4">
      <button @click="toggleSidebar" class="p-1 mr-2 text-gray-500 hover:text-gray-700 focus:outline-none">
         <i class="pi pi-bars text-xl"></i>
      </button>
      <!-- Mobile Toggle (Hidden on LG, but kept for structure if used elsewhere or if we want it here) -->
      <!-- <i @click="toggleSidebar" class="fas fa-bars text-xl cursor-pointer lg:hidden text-gray-500 hover:text-gray-700"></i> -->

      <div>
        <h1 class="text-xl font-bold text-gray-800">{{ pageTitle }}</h1>
        <p class="text-xs text-gray-500">Welcome back, {{ userName }}</p>
      </div>
    </div>

    <div class="flex items-center gap-4">
       <!-- Tour Trigger -->
       <TourTriggerButton />

       <!-- Notification Widget -->
       <NotificationWidget />

       <!-- Download Manager Widget -->
       <DownloadManager />

       <!-- Page guide video (only on pages with a registered guide) -->
       <VideoHelpButton />

       <!-- Academic Calendar -->
      <AcademicCalendarDisplay />

      <!-- User Profile -->
      <UserProfileWidget />
    </div>
  </header>
</template>

<script setup lang="ts">
import { useUserStore } from '@/store/userStore';
import NotificationWidget from '@/components/common/NotificationWidget.vue';
import DownloadManager from '@/components/common/DownloadManager.vue';
import AcademicCalendarDisplay from '@/components/DashBoard/common/AcademicCalendarDisplay.vue';
import UserProfileWidget from '@/components/DashBoard/common/UserProfileWidget.vue';
import TourTriggerButton from '@/components/common/TourTriggerButton.vue';

// Props (Optional if we want to pass title)
// defineProps<{ title?: string }>();

import { menubarItems } from '@/constants/route-details.constant';
import { useSchoolLabels } from '@/composables/useSchoolLabels';

const userStore = useUserStore();
const route = useRoute();
const toggleSidebar = inject('toggleSidebar') as () => void;
const { labels } = useSchoolLabels();

const userName = computed(() => {
  const user = userStore.currentUser;
  if (!user) return 'Admin';
  if ('name' in user) return user.name;
  if ('first_name' in user) return `${user.first_name} ${user.surname}`;
  return 'Admin';
});

const pageTitle = computed(() => {
  let title = 'Overview';

  // 1. Try route meta title
  if (route.meta.title) {
    title = route.meta.title as string;
  } else {
    // 2. Try matching current path with sidebar items
    const activeItem = menubarItems.find(item =>
      route.path === item.path || route.path.startsWith(item.path + '/'),
    );
    if (activeItem) title = activeItem.menuText;
  }

  // 3. Apply dynamic labels
  if (title === 'Staff') {
    return labels.value.TEACHER;
  }
  if (title === 'Students') {
    return labels.value.STUDENT + 's';
  }

  return title;
});
</script>

<style scoped>
</style>
